import React from 'react';
import SVGImage from '../layout/SVGImage';

interface PowerOutageScheduleFilterCheckboxProps {
  text: string;
  testId?: string;
  className?: string;
  isChecked?: boolean;
  onClick?: () => void;
}

export const PowerOutageScheduleFilterCheckbox: React.FC<
  PowerOutageScheduleFilterCheckboxProps
> = ({ testId, className, isChecked, text, onClick }) => {
  const bg = isChecked ? 'bg-white' : 'bg-[#E8EEEE]';
  const border = isChecked ? 'border-[1.5px] border-teal-main' : 'border-none';

  return (
    <label className={`noto-14-medium relative flex items-center ${className}`}>
      <input
        data-testid={testId}
        type="checkbox"
        checked={isChecked}
        onClick={onClick}
        className={`h-5 w-5 appearance-none rounded-[5px] ${border} ${bg} ${className}`}
      />
      {isChecked && (
        <SVGImage className="absolute left-[3px]" name={'checkmark'}></SVGImage>
      )}
      <span className="ml-[10px]" data-testid={`${testId}-label`}>
        {text}
      </span>
    </label>
  );
};
